import i18n from "@/i18n";

export enum TicketStatusCodes {
  OPEN = "ticket_open",
  IN_PROGESS = "ticket_in_progress",
  AWAITING_RESPONSE = "ticket_waiting_response",
  CLIENT_REPLIED = "ticket_client_replied",
  CLOSED = "ticket_closed"
}

export function TicketStatusMap() {
  return {
    [TicketStatusCodes.OPEN]: {
      label: i18n.t("_.open"),
      type: "is-success"
    },
    [TicketStatusCodes.IN_PROGESS]: {
      label: i18n.t("_.in_progress"),
      type: "is-info"
    },
    [TicketStatusCodes.AWAITING_RESPONSE]: {
      label: i18n.t("_.awaiting_response"),
      type: "is-dark"
    },
    [TicketStatusCodes.CLIENT_REPLIED]: {
      label: i18n.t("_.client_replied"),
      type: "is-caution"
    },
    [TicketStatusCodes.CLOSED]: {
      label: i18n.t("_.closed"),
      type: "is-grey"
    }
  };
}

export enum TicketSourceType {
  EMAIL = "email",
  SYSTEM = "system"
}
